import React from "react";

type Props = {
  width: number;
  height: number;
};

export const IconLogoutSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 36.304 29.473`}
    >
      <g transform="matrix(1, 0, 0, 1, 0, 0)">
        <path
          d="M2.559,64H9.6a.642.642,0,0,1,.64.64v.427a.642.642,0,0,1-.64.64H2.559a.856.856,0,0,0-.853.853V81.914a.856.856,0,0,0,.853.853H9.6a.642.642,0,0,1,.64.64v.427a.642.642,0,0,1-.64.64H2.559A2.56,2.56,0,0,1,0,81.914V66.559A2.56,2.56,0,0,1,2.559,64Zm14.875,1.04-.379.379a.64.64,0,0,0,0,.906l7.038,7.006H9.17a.642.642,0,0,0-.64.64V74.5a.642.642,0,0,0,.64.64H24.093l-7.032,7.006a.64.64,0,0,0,0,.906l.379.379a.64.64,0,0,0,.906,0l8.77-8.744a.64.64,0,0,0,0-.906L18.341,65.04A.64.64,0,0,0,17.434,65.04Z"
          transform="translate(4.5 -59.5)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
